import { createFileRoute } from "@tanstack/react-router";
import { BlogPostPage } from "@/components/site/BlogPostPage";
import { POST_BY_SLUG } from "@/lib/blog";
import { articleSchema, faqSchema, breadcrumbSchema } from "@/components/site/SchemaJsonLd";

const SLUG = "why-is-my-water-heater-making-noise-heres-what-it-means";
const post = POST_BY_SLUG[SLUG];
// SEO meta description (the visible subtitle keeps post.description).
const META_DESCRIPTION = "Popping, rumbling, ticking or hissing? Each water heater sound points to a different problem. A Phoenix plumber explains what it means and when to call.";

export const Route = createFileRoute(
  "/why-is-my-water-heater-making-noise-heres-what-it-means",
)({
  head: () => ({
    meta: [
      { title: "Why Is My Water Heater Making Noise? What Each Sound Means" },
      { name: "description", content: META_DESCRIPTION },
      { property: "og:title", content: post.title },
      { property: "og:description", content: META_DESCRIPTION },
      { property: "og:type", content: "article" },
      { property: "og:url", content: `https://www.phoenixplumbing.co/${SLUG}` },
      { name: "twitter:title", content: post.title },
      { name: "twitter:description", content: META_DESCRIPTION },
    ],
    links: [{ rel: "canonical", href: `https://www.phoenixplumbing.co/${SLUG}` }],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(articleSchema({ title: post.title, description: post.description, date: post.date, slug: SLUG })) },
      ...(post.faqs ? [{ type: "application/ld+json", children: JSON.stringify(faqSchema(post.faqs)) }] : []),
      { type: "application/ld+json", children: JSON.stringify(breadcrumbSchema([{ name: "Home", url: "/" }, { name: "Blog", url: "/blog" }, { name: post.title, url: `/${SLUG}` }])) },
    ],
  }),
  component: () => <BlogPostPage post={post} />,
});